import { createContext, useContext } from 'react';

const NodeContext = createContext({});
const NodeContextProvider = NodeContext.Provider;

const useNodeContext = () => useContext(NodeContext);

export { NodeContextProvider, useNodeContext };
